<div class="container py-4">

  <div class="page-header">
    <button class="back-btn" (click)="goBack()" type="button">← Back</button>
    <h1>Analytics</h1>
    <span *ngIf="analytics" class="project-name-badge">{{ analytics.project_name }}</span>
  </div>

  <div *ngIf="loading" class="state-msg">Loading analytics…</div>
  <div *ngIf="!loading && error" class="state-msg state-msg--error">Failed to load analytics.</div>

  <ng-container *ngIf="!loading && !error && analytics">

    <!-- Summary cards -->
    <div class="stats-row">
      <div class="stat-card">
        <span class="stat-card__label">Total views (30 days)</span>
        <span class="stat-card__value">{{ analytics.total_views | number }}</span>
      </div>
      <div class="stat-card" *ngIf="analytics.peak_day">
        <span class="stat-card__label">Peak day</span>
        <span class="stat-card__value">{{ analytics.peak_day.count | number }}</span>
        <span class="stat-card__sub">{{ formatFull(analytics.peak_day.date) }}</span>
      </div>
      <div class="stat-card">
        <span class="stat-card__label">Daily average</span>
        <span class="stat-card__value">{{ (analytics.total_views / 30) | number:'1.1-1' }}</span>
      </div>
    </div>

    <!-- Chart -->
    <div class="chart-card">
      <div class="chart-card__title">Status page views — last 30 days</div>

      <div class="chart-wrapper">
        <svg
          [attr.viewBox]="'0 0 ' + chartWidth + ' ' + chartHeight"
          class="chart-svg"
          xmlns="http://www.w3.org/2000/svg">

          <!-- Grid lines -->
          <line
            *ngFor="let tick of yAxisTicks"
            [attr.x1]="paddingLeft"
            [attr.y1]="tick.y"
            [attr.x2]="chartWidth - paddingRight"
            [attr.y2]="tick.y"
            class="grid-line" />

          <!-- Y axis labels -->
          <text
            *ngFor="let tick of yAxisTicks"
            [attr.x]="paddingLeft - 4"
            [attr.y]="tick.y + 4"
            class="axis-label axis-label--y">{{ tick.value }}</text>

          <!-- Bars -->
          <rect
            *ngFor="let bar of bars"
            [attr.x]="bar.x"
            [attr.y]="bar.y"
            [attr.width]="bar.width"
            [attr.height]="bar.height"
            [class.bar--highlight]="tooltipBar === bar"
            class="bar"
            (mouseenter)="onBarEnter(bar)"
            (mouseleave)="onBarLeave()" />

          <!-- X axis labels -->
          <text
            *ngFor="let lbl of xAxisLabels"
            [attr.x]="lbl.x"
            [attr.y]="chartHeight - 4"
            class="axis-label axis-label--x">{{ lbl.label }}</text>

          <!-- Tooltip -->
          <ng-container *ngIf="tooltipBar">
            <rect
              [attr.x]="tooltipBar.x + tooltipBar.width / 2 - 44"
              [attr.y]="tooltipBar.y - 38"
              width="88"
              height="30"
              rx="5"
              class="tooltip-bg" />
            <text
              [attr.x]="tooltipBar.x + tooltipBar.width / 2"
              [attr.y]="tooltipBar.y - 22"
              class="tooltip-date">{{ formatShort(tooltipBar.data.date) }}</text>
            <text
              [attr.x]="tooltipBar.x + tooltipBar.width / 2"
              [attr.y]="tooltipBar.y - 10"
              class="tooltip-count">{{ tooltipBar.data.count }} view{{ tooltipBar.data.count !== 1 ? 's' : '' }}</text>
          </ng-container>

        </svg>
      </div>
    </div>

  </ng-container>

</div>
